export const SCROLL_TO_DELIVERY_BLOCK_EVENT = "scrollToDeliveryBlock";
export const SCROLL_TO_SHOWROOM_BLOCK_EVENT = "scrollToShowroom";
export const SCROLL_TO_SIMILAR_ITEMS_EVENT = "scrollToSimilarItems";
export const SCROLL_TO_SELLER_BLOCK_EVENT = "scrollToSellerBlock";
